import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { DadosFundoComponent } from "../dados-fundo/dados-fundo.component";
import { AllStockModel } from "./../../model/domain/AllStock";

@Component({
  selector: "app-report-upload",
  templateUrl: "./report-upload.component.html",
  styleUrls: ["./report-upload.component.scss"],
})
export class ReportUploadComponent implements OnInit {
  constructor(private datePipe: DatePipe) {}

  @ViewChild("portfolio", { static: true }) fundoComponent: DadosFundoComponent;

  allStock: AllStockModel = new AllStockModel();

  wallet = true;

  fundPositionDate;
  fundPositionCount = null;
  fundMarketPositionCount;

  fixedPositionDate;
  fixedPositionCount;
  fixedCommittedPositionCount;
  fixedTermPositionCount;

  variablePositionDate;
  variablePositionCount;
  variableOptionsPositionCount;
  variabletermPositionCount;
  variableloanPositionCount;

  otherPositionDate;
  otherPositionCount;
  otherexchangePositionCount;

  derivativePositionDate;
  derivativeFuturesPositionCount;
  derivativeOptionsPositionCount;
  derivativeSwapPositionCount;

  cetipSwapPositionDate;
  cetipSwapPositionCount;

  ngOnInit() {}

  getStockSelectedFund(selectedFundStock: AllStockModel) {
    this.allStock = selectedFundStock;

    this.fundPositionDate = this.allStock?.stockFund?.positionDate;

    this.fundPositionCount = `(Quantidade: ${this.allStock?.stockFund?.positions.length})`;
    this.fundMarketPositionCount = `(Quantidade: ${this.allStock?.stockFund?.marketPositions.length})`;

    this.fixedPositionDate = this.allStock?.stockFixedIncome?.positionDate;
    this.fixedPositionCount = `(Quantidade: ${this.allStock?.stockFixedIncome?.positions.length})`;
    this.fixedCommittedPositionCount = `(Quantidade: ${this.allStock?.stockFixedIncome?.committedPositions.length})`;
    this.fixedTermPositionCount = `(Quantidade: ${this.allStock?.stockFixedIncome?.termPositions.length})`;

    this.variablePositionDate =
      this.allStock?.stockVariableIncome?.positionDate;
    this.variablePositionCount = `(Quantidade: ${this.allStock?.stockVariableIncome?.positions.length})`;
    this.variableOptionsPositionCount = `(Quantidade: ${this.allStock?.stockVariableIncome?.optionsPositions.length})`;
    this.variabletermPositionCount = `(Quantidade: ${this.allStock?.stockVariableIncome?.termPositions.length})`;
    this.variableloanPositionCount = `(Quantidade: ${this.allStock?.stockVariableIncome?.loanPositions.length})`;

    this.otherPositionDate = this.allStock?.stockOtherAsset?.positionDate;
    this.otherPositionCount = `(Quantidade: ${this.allStock?.stockOtherAsset?.positions.length})`;
    this.otherexchangePositionCount = `(Quantidade: ${this.allStock?.stockOtherAsset?.exchangePositions.length})`;

    this.derivativePositionDate = this.allStock?.stockDerivative?.positionDate;
    this.derivativeFuturesPositionCount = `(Quantidade: ${this.allStock?.stockDerivative?.futuresPositions.length})`;
    this.derivativeOptionsPositionCount = `(Quantidade: ${this.allStock?.stockDerivative?.optionsPositions.length})`;
    this.derivativeSwapPositionCount = `(Quantidade: ${this.allStock?.stockDerivative?.swapPositions.length})`;

    this.cetipSwapPositionDate = this.allStock?.stockSwapCetip?.positionDate;
    this.cetipSwapPositionCount = `(Quantidade: ${this.allStock?.stockSwapCetip?.positions.length})`;
  }

  columnsFund: string[] = [
    "fundSourceId",
    "fundName",
    "institutionName",
    "availableQuantity",
    "quotaValue",
    "netValue",
  ];

  columnsFundMarket: string[] = [
    "fundSourceId",
    "institutionName",
    "availableQuantity",
    "result",
    "totalCost",
    "netValue",
  ];

  columnsFixedIncome: string[] = [
    "code",
    "selicCode",
    "operationCode",
    "purchaseDate",
    "issueCode",
    "issuerName",
    "serie",
    "issueDate",
    "dueDate",
    "quantity",
    "pu",
    "purchaseValue",
    "netValue",
  ];

  columnsFixedIncomeCommitted: string[] = [
    "operationCode",
    "purchaseDate",
    "securityName",
    "originalDate",
    "dueDate",
    "issuerName",
    "quantity",
    "pu",
    "purchaseValue",
  ];

  columnsFixedIncomeTerm: string[] = [
    "operationCode",
    "purchaseDate",
    "issuerName",
    "securityName",
    "series",
    "issueDate",
    "dueDate",
    "quantity",
    "pu",
    "purchaseValue",
    "netValue",
  ];

  columnsVariableIncome: string[] = [
    "assetCode",
    "assetName",
    "availableAmount",
    "blockedAmount",
    "totalAmount",
    "price",
    "totalCost",
    "result",
    "netValue",
  ];

  columnsVariableIncomeOptions: string[] = [
    "assetCode",
    "stockObject",
    "type",
    "broker",
    "exerciseValue",
    "dueDate",
    "totalAmount",
    "price",
    "totalCost",
    "result",
    "netValue",
  ];

  columnsVariableIncomeTerm: string[] = [
    "operationCode",
    "stockObject",
    "type",
    "amount",
    "broker",
    "actualTermPrice",
    "originalContractValue",
    "activeCashValue",
    "passiveCashValue",
    "dueDate",
    "businessDaysDeadline",
  ];

  columnsVariableIncomeLoan: string[] = [
    "operationCode",
    "assetCode",
    "assetName",
    "broker",
    "loanDate",
    "dueDate",
    "loanAmount",
    "loanValue",
    "remuneration",
    "isDonor",
  ];

  columnsOtherAsset: string[] = [
    "assetCode",
    "assetName",
    "assetType",
    "movementCode",
    "date",
    "value",
  ];

  columnsOtherAssetExchange: string[] = [
    "assetCode",
    "description",
    "dueDate",
    "soldCurrency",
    "purchasedCurrency",
    "soldCurrencyValue",
    "purchasedCurrencyValue",
    "initialParity",
    "currentParity",
    "value",
    "modality",
  ];

  columnsDerivativeFutures: string[] = [
    "assetCode",
    "expiration",
    "dueDate",
    "broker",
    "amount",
    "valuationAdjustment",
    "marketPrice",
    "marketValue",
  ];

  columnsDerivativeOptions: string[] = [
    "assetCode",
    "expiration",
    "dueDate",
    "broker",
    "function",
    "exerciseValue",
    "type",
    "amount",
    "averageValue",
    "price",
    "totalCost",
    "marketValue",
  ];

  columnsDerivativeSwap: string[] = [
    "assetCode",
    "series",
    "dueDate",
    "broker",
    "amount",
    "marketValue",
    "couponTip",
    "finalValueTip",
    "adjust",
  ];
  columnsCetipSwap: string[] = [
    "operationCode",
    "broker",
    "counterpart",
    "startDate",
    "appreciationInitialDate",
    "dueDate",
    "financial",
    "passiveIndexer",
    "passiveTaxValue",
    "passiveFinancial",
    "activeIndexer",
    "activeTaxValue",
    "activeFinancial",
    "appropriateNetFinancial",
  ];
}
